export default __webpack_public_path__ + "static/media/icon_position_curation_all.4c1a3918.svg";